import {
    Box,
    Drawer,
    DrawerContent,
    useDisclosure
} from '@chakra-ui/react';
import {SidebarContent} from "./SidebarContent";
import {MobileNav} from "./MobileNav";

const SideBarWrapper = ({titleComponent, children}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    return (
        <Box minH="100vh" >
            <SidebarContent onClose={() => onClose} display={{base: 'none', md: 'block'}}/>
            {/*<Drawer*/}
            {/*    isOpen={isOpen}*/}
            {/*    placement="left"*/}
            {/*    onClose={onClose}*/}
            {/*    returnFocusOnClose={false}*/}
            {/*    onOverlayClick={onClose}*/}
            {/*    size="full">*/}
            {/*    <DrawerContent>*/}
            {/*        <SidebarContent onClose={onClose}/>*/}
            {/*    </DrawerContent>*/}
            {/*</Drawer>*/}
            <MobileNav isOpen={isOpen} onOpen={onOpen} titleComponent={titleComponent}/>
            <Box ml={{base: 0, md: 60}} px="10" pt="5" overflowY={"hidden"}>
                {children}
            </Box>
        </Box>
    )
}

export default SideBarWrapper;